import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";

import axios from 'axios'
import ReactRouterPropTypes from 'react-router-prop-types';

import Autosuggest from 'react-autosuggest';
import { Router, browserHistory, Link } from "react-router-dom";
import theme from "./theme.css";


// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>
    {
      suggestion.public == 2 ?
      (
        <Fragment>
          <span className="badge bg-primary ml-1">{suggestion.name}</span>
        </Fragment>
      )
      :
      (
        <Fragment>
          {suggestion.name}
        </Fragment>
      ) 
    
    }
  </div>
);


//검색창 출력
class PixelogSearch extends Component {

  constructor(props) {
    super();
    // console.log(props);
    var val = props.history.location.pathname.split('=').[1];

    if(val == undefined){
      val = '';
    }

    this.state = {
      value: val,
      suggestions: [],
      selected: "",     
    };
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
  };

  onSuggestionsFetchRequested = async ({ value }) => {
    const suggestions = await this.getSuggestions(value);

    this.setState({
      suggestions: suggestions,
      selected: false
    });
  };

  onKeyPress = e => {
      const { suggestions, value, selected } = this.state;
      const { history } = this.props;
      const encodedSearchTerm = encodeURIComponent(value);

    if (e.key === "Enter" && selected == "") {      

      //console.log(value);
      // console.log('enter');

      this.setState({
        value: value,
        suggestions: [],
        selected: { method: "enter", suggestions, value },
      });

      history.push(`/search/query=${encodedSearchTerm}`);
    }
  };

  getSuggestions = value => {

    let form = new FormData(); 
    form.append('query', value)

    return new Promise(resolve => {
      axios
        .post(`/pixelog/searchMain`, form)
        .catch(error => {
          console.log(error);
        })
        .then(response => {
          //console.log(response);
          !response || response.data.error
            ? resolve([])
            : resolve(response.data);
        });
    });
  };

  getSuggestionValue = suggestion => this.state.value;

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  onSuggestionSelected = (event, { suggestion, suggestionValue, method }) => {

    const { history } = this.props;

    this.setState({
      value: suggestion.name,
      suggestions: [],
      selected: { suggestion, method },
    });

    const encodedSearchTerm = encodeURIComponent(suggestion.name);
    // console.log('N', suggestion.name);
    // console.log('Y', encodedSearchTerm);


    if(suggestion.public == '1'){
      history.push(`/search/title=${encodedSearchTerm}`);
      // history.push({
      //  pathname: `/search/title=${encodedSearchTerm}`,
      //  state: {type:'title', query:`${encodedSearchTerm}`, offset:0, limit:50}
      // });
      // type = 'title';
    }else if(suggestion.public == '2'){
      history.push(`/search/tag=${encodedSearchTerm}`);
      // type = 'tag';
    }else{
      history.push(`/search/query=${encodedSearchTerm}`);
      // type = 'query';
    }

  };

  shouldComponentUpdate(nextProps, nextState){;
    // console.log('shouldComponentUpdate');
    // console.log(nextProps);
    // console.log(nextState);
    // console.log(this.state);
    // console.log(this.props);


    // console.log('-----------------------------------');

    if(this.props.history.location.state !== undefined && this.state.selected !== false){
    // console.log(this.state.value);
  //    console.log(this.props.history.location.state.query);
      if(this.props.history.location.state.query !== undefined){

        if(this.state.value !== this.props.history.location.state.query){
          //console.log('dddd');
          this.setState({
            value: this.props.history.location.state.query
          });
          return true;
        }

      }

    }
    // console.log('123123');
    //if(this.state.value !== this.props.location.state.query)
    //
    // console.log('-----------------------------------');
    return true;
  }
  
  render() {

    const { value, suggestions } = this.state;

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: '검색',
      value,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
    };

    return (
            <Autosuggest
              suggestions={suggestions}
              onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
              onSuggestionsClearRequested={this.onSuggestionsClearRequested}
              onSuggestionSelected={this.onSuggestionSelected}
              getSuggestionValue={this.getSuggestionValue}
              renderSuggestion={renderSuggestion}
              inputProps={inputProps}
            />
        );
  }
}

export default PixelogSearch;
